<template>
  <div class="part table projects-list" v-if="projects && Array.isArray(projects)">
    <a-table
      :columns="columns"
      :dataSource="projects"
      :rowKey="(record, index) => record._id"
      :scroll="{ x: 1200 }"
      :customRow="rowClick"
      :pagination="pagination"
      @change="change"
    >
      <span slot="id" slot-scope="_id">
        <strong>{{ shortID(_id) }}</strong>
      </span>

      <span slot="status" slot-scope="project">
        <a-tag class="status" :class="project.status"> {{ project.status | PROJECT_STATUS_ }} </a-tag>
      </span>

      <span slot="property" slot-scope="property">{{ property | PROPERTY_ }}</span>

      <span slot="services" slot-scope="services">
        <div class="services-group">
          <span v-for="service in services" :key="service">{{ service | SERVICE_ }}</span>
        </div>
      </span>

      <span slot="description" slot-scope="description">
        <div class="sticker">{{ description }}</div>
      </span>

      <span slot="source" slot-scope="source">
        {{ source | SOURCE_ }}
      </span>

      <span slot="created_at" slot-scope="created_at">
        <span> {{ created_at | moment('ll') }} </span>
      </span>
    </a-table>
  </div>
</template>

<script>
import router from '@/router'
import { shortID } from '@/utils/formators'

export default {
  name: 'table-projects',
  props: ['projects', 'pagination', 'loading'],

  data() {
    return {
      columns: [
        {
          title: 'ID',
          dataIndex: '_id',
          key: '_id',
          width: '80px',
          fixed: 'left',
          scopedSlots: { customRender: 'id' },
        },
        {
          title: 'Status',
          key: 'status',
          width: '120px',
          align: 'center',
          filters: [
            {
              text: 'Pending',
              value: 'pending',
            },
            {
              text: 'Active',
              value: 'active',
            },
          ],
          filterMultiple: false,
          onFilter: (status, project) => project.status.indexOf(status) === 0,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: 'Location',
          dataIndex: 'location',
          key: 'location',
        },
        {
          title: 'Property',
          dataIndex: 'property',
          key: 'property',
          scopedSlots: { customRender: 'property' },
        },
        {
          title: 'Services',
          dataIndex: 'services',
          key: 'services',
          width: '200px',
          scopedSlots: { customRender: 'services' },
        },
        {
          title: 'Description',
          dataIndex: 'description',
          key: 'description',
          width: '220px',
          scopedSlots: { customRender: 'description' },
        },
        {
          title: 'Source',
          dataIndex: 'source',
          key: 'source',
          scopedSlots: { customRender: 'source' },
        },
        {
          title: 'Created',
          dataIndex: 'created_at',
          key: 'created_at',
          scopedSlots: { customRender: 'created_at' },
        },
      ],
    }
  },
  methods: {
    shortID,
    rowClick: (record) => ({
      on: {
        click: (e) => router.push({ name: 'project-detail', params: { id: record._id } }),
      },
    }),
    change: (pagination, filters, sorter) => {
      store.dispatch('crm/updateQuery', { key: KEY, query: { pagination, filters, sorter } })
    },
  },
}
</script>

<style lang="scss" scoped>
.table.projects-list {
  .status {
    border: none;
    text-transform: capitalize;
    background: #666;
    color: #fff;

    &.confirmed {
      background: #00b44b;
    }

    &.in_progress {
      background: #008d0c;
    }
  }

  .sticker {
    background: #ffeb3b;
    padding: 2px 8px;
    color: #000;
    border-radius: 3px;
    font-size: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    box-shadow: 0 0 10px #eee;
  }

  .services-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 1px;
    span {
      font-size: 12px;
    }
  }
}
</style>
